import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getArticulos, tableData } from "./handlers";
import { Table } from "../../components";
import MuniSpinner from "../../components/MuniSpinner/index";
import { UserContext } from "../../context";

const Articulos = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [articulos, setArticulos] = useState([]);
  const [precioUnidad, setPrecioUnidad] = useState(null);
  const { actions: ua } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (ua.hasPermission("articulos.view")) {
      getArticulos(setIsLoading, setArticulos, setPrecioUnidad);
    } else {
      navigate("/");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div>
        <div className='d-flex gap-4 mb-1 align-items-center'>
          <h3>Articulos</h3>
        </div>
        {isLoading ? (
          <MuniSpinner />
        ) : (
          !isLoading &&
          articulos && (
            <>
              <Table
                data={tableData(articulos, ua)}
                render={() => (
                  <Link to='/' className='my-auto  ms-auto me-1 btn btn-primary' style={{ maxHeight: "38px" }}>
                    <span>Volver</span>
                  </Link>
                )}
                name='articulos'
              />
            </>
          )
        )}
      </div>
    </>
  );
};

export default Articulos;
